"use client";

import React, { useState } from "react";
import { Button } from "primereact/button";

import { EmpBillsValidationForm } from "./EmpBillsValidationForm";

export function EmpBillsValidationButton() {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Button
        className="w-12rem md:my-4 h-4rem"
        label="Validate EMP Bills"
        icon="pi pi-check-circle"
        onClick={() => setModalVisible(true)}
      />

      <EmpBillsValidationForm
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
}
